import "./token.mjs";
import "ethers";
import "@deorderbook/contracts/abi";
import "../store/provider.mjs";
import "@deorderbook/contracts";
import "../store/subgraph.mjs";
import { useSellTokenContract as o } from "../store/sellTokenContract.mjs";
function c(t) {
  return o().balanceOf(t);
}
function m(t, r) {
  return o().allowance(t, r);
}
function f(t, r) {
  return o(!0).approve(t, r);
}
function S() {
  return o().totalSupply();
}
export {
  m as allowance,
  f as approve,
  c as balanceOf,
  S as totalSupply
};
//# sourceMappingURL=token_sell_token.mjs.map
